// src/pages/Dashboard/Admin/SeasonStats/components/SeasonBreakdownChart.jsx

import React, { useMemo } from "react";

import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { getChartData } from "../utils/seasonStatsDashboardUtils";

const COLORS = [
  "#013E8E",
  "#EC4899",
  "#06B6D4",
  "#4CA82F",
  "#F59E0B",
  "#8B5CF6",
  "#F97316",
];

export default function SeasonBreakdownChart({
  seasonStat,
  type,
  title,
  subtitle,
  mode = "bar",
}) {
  const data = useMemo(
    () => getChartData(seasonStat, type),
    [seasonStat, type],
  );

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="p-4 sm:p-5 lg:p-6">
        <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
          Répartition
        </p>

        <h2 className="mt-1 text-lg font-bold text-slate-900 dark:text-white">
          {title}
        </h2>

        {subtitle ? (
          <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
            {subtitle}
          </p>
        ) : null}

        <div className="mt-5 h-[300px]">
          {data.length === 0 ? (
            <div className="flex h-full items-center justify-center rounded-2xl bg-slate-50 text-sm text-slate-500 dark:bg-slate-800/40 dark:text-slate-400">
              Aucune donnée enregistrée.
            </div>
          ) : mode === "pie" ? (
            <ResponsiveContainer
              width="100%"
              height="100%"
            >
              <PieChart>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  innerRadius={55}
                  outerRadius={95}
                  paddingAngle={3}
                  label={({ name, value }) =>
                    `${name} : ${value}`
                  }
                >
                  {data.map((entry, index) => (
                    <Cell
                      key={`${entry.code}-${index}`}
                      fill={
                        COLORS[
                          index % COLORS.length
                        ]
                      }
                    />
                  ))}
                </Pie>

                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <ResponsiveContainer
              width="100%"
              height="100%"
            >
              <BarChart
                data={data}
                layout="vertical"
                margin={{
                  top: 0,
                  right: 20,
                  bottom: 0,
                  left: 10,
                }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  opacity={0.2}
                />

                <XAxis
                  type="number"
                  allowDecimals={false}
                />

                <YAxis
                  type="category"
                  dataKey="name"
                  width={95}
                  tick={{ fontSize: 11 }}
                />

                <Tooltip />

                <Bar
                  dataKey="value"
                  name="Adhérents"
                  radius={[0, 8, 8, 0]}
                  fill="#013E8E"
                />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </section>
  );
}